// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * GDS API Internal
 * <!-- used by swagger --> An Internal API to manage Aura Graph Analytics Sessions. Intended to be used by other components inside Aura. These endpoints require mtls and are not exposed to the public.
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalendpointsSessionSummary } from './InternalendpointsSessionSummary';
import {
  InternalendpointsSessionSummaryFromJSON,
  InternalendpointsSessionSummaryFromJSONTyped,
  InternalendpointsSessionSummaryToJSON,
  InternalendpointsSessionSummaryToJSONTyped,
} from './InternalendpointsSessionSummary';

/**
 *
 * @export
 * @interface InternalendpointsListSessionsResponse
 */
export interface InternalendpointsListSessionsResponse {
  /**
   *
   * @type {Array<InternalendpointsSessionSummary>}
   * @memberof InternalendpointsListSessionsResponse
   */
  sessions?: Array<InternalendpointsSessionSummary>;
  /**
   *
   * @type {number}
   * @memberof InternalendpointsListSessionsResponse
   */
  totalCount?: number;
}

/**
 * Check if a given object implements the InternalendpointsListSessionsResponse interface.
 */
export function instanceOfInternalendpointsListSessionsResponse(
  value: object,
): value is InternalendpointsListSessionsResponse {
  return true;
}

export function InternalendpointsListSessionsResponseFromJSON(
  json: any,
): InternalendpointsListSessionsResponse {
  return InternalendpointsListSessionsResponseFromJSONTyped(json, false);
}

export function InternalendpointsListSessionsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): InternalendpointsListSessionsResponse {
  if (json == null) {
    return json;
  }
  return {
    sessions:
      json['sessions'] == null
        ? undefined
        : (json['sessions'] as Array<any>).map(
            InternalendpointsSessionSummaryFromJSON,
          ),
    totalCount: json['total_count'] == null ? undefined : json['total_count'],
  };
}

export function InternalendpointsListSessionsResponseToJSON(
  json: any,
): InternalendpointsListSessionsResponse {
  return InternalendpointsListSessionsResponseToJSONTyped(json, false);
}

export function InternalendpointsListSessionsResponseToJSONTyped(
  value?: InternalendpointsListSessionsResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    sessions:
      value['sessions'] == null
        ? undefined
        : (value['sessions'] as Array<any>).map(
            InternalendpointsSessionSummaryToJSON,
          ),
    total_count: value['totalCount'],
  };
}
